import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Printer, CheckCircle2 } from "lucide-react";
import axios from "axios";
import authHeader from "../../../Auth/authHeader";
import { getAuthData } from "../../../Auth/getAuthData";
import { ApiLink } from "../../../APILink/ApiLink";
import "./FiscalPrinterTab.scss";

const toFiscalPrinterValue = (activePrinterType) => {
  return activePrinterType || "0";
};

export default function FiscalPrinterTab({ initialData, onUpdate }) {
  const authData = getAuthData();
  const userCompanyUnitID = Number(authData?.companyUnitId || 0);
  const isCompanyUnitUser = userCompanyUnitID > 0;
  const [data, setData] = useState(initialData || {});
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setData(initialData || {});
  }, [initialData]);

  const printers = [
    {
      id: "0",
      name: "Pa printer fiskal",
      description: "Caktivizo integrimin e printimit fiskal.",
    },
    {
      id: "1",
      name: "DATECS FP700",
      description: "Printer fiskal sipas konfigurimit ekzistues te kompanise.",
    },
    {
      id: "2",
      name: "TREMOL FP15",
      description: "Printer fiskal sipas konfigurimit ekzistues te kompanise.",
    },
  ];

  const handlePrinterSelect = async (printerId, printerName) => {
    if (isSaving || data.activePrinterType === printerId) return;
    const previousData = { ...data };
    const newData = { ...data, activePrinterType: printerId };
    setData(newData);

    try {
      setIsSaving(true);
      const headers = authHeader();

      if (isCompanyUnitUser) {
        await axios.put(
          ApiLink.API_URL + "CompanyUnits/updateFiscalPrinter",
          {
            UnitID: userCompanyUnitID,
            FiscalPrinter: toFiscalPrinterValue(newData.activePrinterType),
          },
          { headers }
        );
      } else if (newData.companyId) {
        await axios.put(
          ApiLink.API_URL + "Companies/updateFiscalPrinter",
          { CompanyID: newData.companyId, FiscalPrinter: toFiscalPrinterValue(newData.activePrinterType) },
          { headers }
        );
      }

      const updatedRecord = {
        ...newData,
        id: newData.id || newData.companyId,
      };

      setData({ ...updatedRecord });
      onUpdate({ ...updatedRecord });

      if (printerId === "0") {
        toast("Printeri fiskal u caktivizua.", {
          duration: 3500,
          icon: "⛔",
          style: {
            background: "var(--cc-kpi-warning-bg)",
            color: "var(--cc-kpi-warning-text)",
            border: "1px solid var(--cc-kpi-warning-ring)",
            fontWeight: "600",
          },
        });
      } else {
        toast.success(`Printeri aktiv u vendos: ${printerName}.`, {
          duration: 3500,
          style: {
            background: "var(--cc-kpi-positive-bg)",
            color: "var(--cc-kpi-positive-text)",
            border: "1px solid var(--cc-kpi-positive-ring)",
            fontWeight: "600",
          },
          iconTheme: { primary: "var(--cc-kpi-positive-text)", secondary: "var(--cc-kpi-positive-bg)" },
        });
      }
    } catch (error) {
      setData(previousData);
      toast.error("Ndryshimi i printerit fiskal nuk u ruajt. Provo perseri.", {
        duration: 4000,
        style: {
          background: "var(--cc-kpi-negative-bg)",
          color: "var(--cc-kpi-negative-text)",
          border: "1px solid var(--cc-kpi-negative-ring)",
          fontWeight: "600",
        },
        iconTheme: { primary: "var(--cc-kpi-negative-text)", secondary: "var(--cc-kpi-negative-bg)" },
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fiscal-printer-tab">
      <div className="fiscal-printer-tab__header">
        <h2 className="fiscal-printer-tab__title">
          <Printer className="fiscal-printer-tab__title-icon" />
          Konfigurimi i Printerit Fiskal
        </h2>
        <p className="fiscal-printer-tab__subtitle">
          Zgjidh printerin fiskal aktiv. Ndryshimi ruhet automatikisht ne momentin e klikimit.
        </p>
      </div>

      <div className="fiscal-printer-tab__selection-card">
        <h3 className="fiscal-printer-tab__selection-title">Zgjedhja e Tipit te Printerit</h3>
        <div className="fiscal-printer-tab__printer-grid">
          {printers.map((printer) => (
            <label
              key={printer.id}
              className={`fiscal-printer-tab__printer-item ${data.activePrinterType === printer.id ? "is-active" : ""}`}
            >
              <input
                type="radio"
                name="activePrinterType"
                value={printer.id}
                className="fiscal-printer-tab__radio"
                checked={data.activePrinterType === printer.id}
                onChange={() => handlePrinterSelect(printer.id, printer.name)}
                disabled={isSaving}
              />
              <span className="fiscal-printer-tab__printer-content">
                <span className="fiscal-printer-tab__printer-text">
                  <span className="fiscal-printer-tab__printer-name">
                    {printer.name}
                  </span>
                  <span className="fiscal-printer-tab__printer-description">
                    {printer.description}
                  </span>
                </span>
              </span>
              <CheckCircle2
                className={`fiscal-printer-tab__check-icon ${data.activePrinterType === printer.id ? "is-visible" : ""}`}
                aria-hidden="true"
              />
            </label>
          ))}
        </div>
      </div>

      {/*
      {data.activePrinterType !== 'none' && (
        <div className="fiscal-printer-tab__config-card">
          <div className="fiscal-printer-tab__config-header">
            <h3 className="fiscal-printer-tab__config-title">
              Detajet e Konfigurimit
            </h3>
            {testResult === 'success' && <span className="fiscal-printer-tab__status fiscal-printer-tab__status--success"><CheckCircle2 className="fiscal-printer-tab__status-icon"/> I lidhur</span>}
            {testResult === 'error' && <span className="fiscal-printer-tab__status fiscal-printer-tab__status--error"><XCircle className="fiscal-printer-tab__status-icon"/> Deshtoi</span>}
          </div>
          
          <div className="fiscal-printer-tab__config-grid">
            <div className="fiscal-printer-tab__field">
              <label htmlFor="printerIp" className="fiscal-printer-tab__label">Adresa IP *</label>
              <input
                id="printerIp"
                name="printerIp"
                value={data.printerIp || ''}
                onChange={handleChange}
                placeholder="192.168.1.100"
                className="fiscal-printer-tab__input"
              />
            </div>
            
            <div className="fiscal-printer-tab__field">
              <label htmlFor="printerPort" className="fiscal-printer-tab__label">Porta *</label>
              <input
                id="printerPort"
                name="printerPort"
                value={data.printerPort || ''}
                onChange={handleChange}
                placeholder="9100"
                className="fiscal-printer-tab__input"
              />
            </div>
            
            <div className="fiscal-printer-tab__field">
              <label htmlFor="printerConnectionType" className="fiscal-printer-tab__label">Lloji i Lidhjes</label>
              <select
                id="printerConnectionType"
                name="printerConnectionType"
                value={data.printerConnectionType || 'network'}
                onChange={handleChange}
                className="fiscal-printer-tab__select"
              >
                <option value="network">Rrjet (TCP/IP)</option>
                <option value="usb">Porta USB</option>
              </select>
            </div>
            
            <div className="fiscal-printer-tab__field">
              <label htmlFor="printerDeviceId" className="fiscal-printer-tab__label">ID e Pajisjes</label>
              <input
                id="printerDeviceId"
                name="printerDeviceId"
                value={data.printerDeviceId || ''}
                onChange={handleChange}
                placeholder="DEV-XXX"
                className="fiscal-printer-tab__input"
              />
            </div>
          </div>
          
          <div className="fiscal-printer-tab__config-actions">
            <button 
              type="button" 
              onClick={handleTestConnection} 
              disabled={isTesting}
              className="fiscal-printer-tab__test-btn"
            >
              <RefreshCw className={`fiscal-printer-tab__test-icon ${isTesting ? 'is-spinning' : ''}`} />
              {isTesting ? 'Duke testuar...' : 'Testo Lidhjen'}
            </button>
          </div>
        </div>
      )}
      */}
    </div>
  );
}